module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-BLOG-PLOT-2-small-7016998a41ace240a123a8c983bf9a54.jpeg";